/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Row, Col } from 'react-bootstrap';
import { Button, TextField } from '@material-ui/core';
import mControl from './Info.Controler'
import validate from 'validate.js';



const TaxService = (props) => {
    const kodeoutlet = props.kodeoutlet;
    const clientID = props.clientID
    const token = props.token
    const [isRefresh, setIsRefresh] = useState(true)
    const [form, setForm] = useState({
        phoneNumber: '',
        address: ''
    })
    useEffect(() => {
        if (isRefresh) {
            mControl.loadOutletDet(kodeoutlet, clientID, token).then(resp => {
                setForm(resp);
            }).catch(err => {
                console.error(err);
            }).finally(() => setIsRefresh(false))
        }
        return () => {
        };
    }, [kodeoutlet, clientID, token, isRefresh]);
    const handleChange = (ev) => {
        var value = ev.target.value;
        const key = ev.target.id || ev.target.name;
        var newForm = { ...form }
        newForm[key] = value;
        setForm(newForm);
    }
    const validateForm = () => {
        const promNamaOutlet = new Promise((resolve, reject) => {
            //  const myFormat = /^(\+62|\+0|0|62)8(1[123]|52|51|53|21|22|23)[0-9]{5,9}$|^(\+62815|0815|62815|\+0815|\+62816|0816|62816|\+0816|\+62858|0858|62858|\+0814|\+62814|0814|62814|\+0814)[0-9]{5,9}$|^(\+62855|0855|62855|\+0855|\+62856|0856|62856|\+0856|\+62857|0857|62857|\+0857)[0-9]{5,9}$|^(\+62817|0817|62817|\+0817|\+62818|0818|62818|\+0818|\+62819|0819|62819|\+0819|\+62859|0859|62859|\+0859|\+0878|\+62878|0627|0629|06410642|0643|0644|0645|0646|0650|0651|0652|0653|0654|0655|0656|0657|0658|0659|061|0620|0621|0622|0623|0624|0625|0626|0627|0628|0630|0631|0632|0633|0634|0635|0636|0639|0751|0752|0753|0754|0755|0756|0757|0759|0760|0761|0762|0763|0764|0765|0766|0767|0768|0769|0624|0770|0771|0772|0773|0776|0777|0778|0779|0740|0741|0742|0743|0744|0745|0746|0747|0748|0702|0711|0712|0713|0714|0730|0731|0733|0734|0735|0715|0716|0717|0718|0719|0732|0736|0737|0738|0739|0721|0722|0723|0724|0725|0726|0727|0728|0729|021|0252|0253|0254|0257|022|0231|0232|0233|0234|0251|0260|0261|0262|0263|0264|0265|0266|0267|0274|024|0271|0272|0273|0274|0275|0276|0280|0281|0282|0283|0284|0285|0286|0287|0289|0291|0292|0293|0294|295|0296|0297|0298|0299|0356|031|0321|0322|0323|0324|0325|0327|0328|0331|0332|0333|0334|0335|0336|0338|0341|0342|0343|0351|0352|0353|0354|0355|0356|0357|0358|0361|0362|0363|0365|0366|0368| 0364|0370|0371|0372|0373|0374|0376|0380|0381|0382|0383|0384|0385|0386|0387|0388|0389|0561|0562|0563|0564|0565|0567|0568|0534|0513|0522|0525|0526|0528|0531|0532|0536|0537|0538|0539|0511|0512|0517|0518|0526|0527|0541|0542|0543|0545|0548|0549|0554|0551|0552|0553|0556|0430|0431|0432|0434|0438|0435|0443|0445|0450|0451|0452|0453|0454|0457|0458|0461|0462|0463|0464|0465|0455|0422|0426|0428|0410|0411|0413|0414|0417|0418|0419|0420|0421|0423|0427|0471|0472|0473|0474|0475|0481|0482|0484|0485|0401|0402|0403|0404|0405|0408|0910|0911|0913|0914|0915|0916|0917|0918|0921|0922|0923|0924|0927|0929|0931|0901|0902|0951|0952|0955|0956|0957|0966|0967|0969|0971|0975|0980|0981|0983|0984|0985|0986|0878|62878|\+0877|\+62877|0877|62877)[0-9]{5,9}$|^(\+62|\+0|0|62)8(28)[0-9]{5,9}$|^(\+62|\+0|0|62)8(3[128])[0-9]{5,9}$|^(\+62|\+0|0|62)8(8[1278])[0-9]{5,9}$|^(\+62|\+0|0|62)8(9[678])[0-9]{5,9}$/g;
            const constraint = {
                phoneNumber: {
                    length: {
                        minimum: 9,
                        message: "Nomor Handphone terlalu pendek"
                    },
                    // format: {
                    //     pattern: myFormat,
                    //     message: "Nomor Handphone tidak sesuai dengan format operator Indonesia."
                    // }
                },
                address: {
                    length: {
                        miminum: 10,
                        message: "Alamat terlalu pendek. Harap mengisi alamat lengkap"
                    }
                },
            }
            const validator = validate(form, constraint, { fullMessages: false });
            if (validator === undefined) {
                resolve();
            } else {
                reject(validator);
            }
        })
        return Promise.all([promNamaOutlet]);
    }

    const handleSaveUser = () => {
        validateForm().then(() => {
            mControl.updateOutlet(clientID, token, form).then(resp => {
                if (resp) {
                    alert("Data berhasil disimpan")
                    setIsRefresh(true)
                } else {
                    alert("Gagal simpan data")
                }
            }).catch(err => {
                if (err.length > 0) {
                    alert(err[0].message)
                } else if (typeof err) {
                    alert(err.message)
                } else {
                    console.log(err);
                }
            })
        }).catch(err => {
            console.log(err)
            const keys = Object.keys(err);
            var errorMessage = "";
            for (const key of keys) {
                errorMessage += err[key] + "\n";
            }
            // console.log(err);
            alert(errorMessage);
        })

    }
    return (
        <React.Fragment>
            <Col xs={12} lg={12}>
                <TextField
                    id="phoneNumber"
                    label="Telp"
                    value={form.phoneNumber}
                    fullWidth
                    required
                    type="telp"
                    onChange={handleChange}
                />
                <TextField
                    id="address"
                    label="Alamat"
                    value={form.address}
                    fullWidth
                    required
                    multiline={true}
                    rows={2}
                    onChange={handleChange}
                />
            </Col>
            <Col xs={12} className="text-center" style={{ marginTop: 20 }}>
                <Button variant="contained" color="primary" onClick={handleSaveUser}>Simpan</Button>
            </Col>


        </React.Fragment>
    );
}
export default TaxService;